// extracted by mini-css-extract-plugin
module.exports = {"image_preview_container":"styles_image_preview_container__2jads","image_preview_image":"styles_image_preview_image__S2SHm","open_composer_btn":"styles_open_composer_btn__2-WpL"};